export default __webpack_public_path__ + "static/media/home_tips_bg.a5fd7248.png";